import { render, staticRenderFns } from "./OrdersBikes.vue?vue&type=template&id=ed9ac300&scoped=true"
import script from "./OrdersBikes.vue?vue&type=script&lang=js"
export * from "./OrdersBikes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9ac300",
  null
  
)

export default component.exports